import React, { useEffect } from 'react';
import { Input, Text, InputTextArea } from '@brokerbay/elements-web';
import { AccessOptionProps } from '../../types';

const DoorCode: React.FC<AccessOptionProps> = ({
  showingsConfig,
  showValidationError,
  setShowingsConfig,
  setIsValid,
}) => {
  const isDetailsFilled =
    Boolean(showingsConfig.instructions.doorcode?.code) ||
    Boolean(showingsConfig.instructions.doorcode?.details);

  useEffect(() => {
    setIsValid(isDetailsFilled);
  }, [isDetailsFilled, setIsValid]);

  return (
    <>
      <div>
        <Input
          label="Door Code instructions"
          dataCy="showing-notification-door-code-instructions"
          labelExtra="(optional)"
          value={showingsConfig.instructions.doorcode?.code || ''}
          onChange={value =>
            setShowingsConfig(prev => ({
              ...prev,
              instructions: {
                ...prev.instructions,
                doorcode: {
                  details: '',
                  ...(prev.instructions.doorcode || {}),
                  code: value,
                },
              },
            }))
          }
        />
      </div>
      <div>
        <InputTextArea
          label="Special access instructions"
          dataCy="showing-notification-special-access-instructions"
          required
          minHeight={100}
          value={showingsConfig.instructions.doorcode?.details || ''}
          onChange={value =>
            setShowingsConfig(prev => ({
              ...prev,
              instructions: {
                ...prev.instructions,
                doorcode: {
                  code: '',
                  ...(prev.instructions.doorcode || {}),
                  details: value,
                },
              },
            }))
          }
          error={
            showValidationError && !isDetailsFilled
              ? 'Details are required'
              : undefined
          }
        />
      </div>
    </>
  );
};

export default DoorCode;
